module.exports = __webpack_public_path__ + "img/home_content_02@2x.b1efdc96.png";